// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"803":"6f6d22f1","888":"6b9a6464"}[chunkId] + ".chunk.css";
};